// Реплика тренера (src/lib/coach-lines.ts) — наклейкой, как совет дня, но с
// подписью «тренер» или автором цитаты. Решение владельца от 30 октября 2026.

import { useMemo } from "react";
import { coachLine, coachSeed, type CoachSituation } from "../lib/coach-lines";

export function CoachNote({
  situation,
  vars,
  seedParts,
  className = "",
}: {
  situation: CoachSituation;
  vars?: Partial<Record<"days" | "need" | "weeks" | "left", number>>;
  /** Из чего зерно: ключ ученика, дата, место — строка не скачет в пределах дня. */
  seedParts: string[];
  className?: string;
}) {
  const key = JSON.stringify([situation, vars ?? {}, seedParts]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const line = useMemo(() => coachLine(situation, vars, coachSeed(...seedParts, situation)), [key]);
  return (
    <figure className={`sticker coach-note ${className}`} aria-label="Тренер">
      <blockquote>{line.author === null ? line.text : `«${line.text.replace(/^«|»$/g, "")}»`}</blockquote>
      <figcaption>{line.author ?? "тренер"}</figcaption>
    </figure>
  );
}
